// extracted by mini-css-extract-plugin
module.exports = {"shards":"shards_shards__nPqDh","background":"shards_background__wWdwn"};